import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Eyebrow } from "@/components/Reveal";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FFFFFF]" data-testid="admin-login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.pexels.com/photos/33685861/pexels-photo-33685861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000" alt="Interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C2A29]/30" />
        <Link to="/" className="absolute top-8 left-8 font-display text-3xl font-semibold text-[#FFFFFF]">Afurnix</Link>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Eyebrow>Admin Access</Eyebrow>
          <h1 className="font-display text-4xl font-medium text-[#2C2A29] mt-3 mb-8">Welcome back.</h1>
          {error && <p className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2" data-testid="login-error">{error}</p>}
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="label-eyebrow text-[#5E5A54]">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none bg-white border-[#ECEAE4] h-12" data-testid="login-email" />
            </div>
            <div className="space-y-1.5">
              <Label className="label-eyebrow text-[#5E5A54]">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-none bg-white border-[#ECEAE4] h-12" data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-none bg-[#2C2A29] hover:bg-[#4A4641] text-[#FFFFFF] h-12 label-eyebrow text-[10px]" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </div>
          <Link to="/" className="block mt-6 text-sm text-[#5E5A54] hover:text-[#2C2A29] font-light">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
